async function bootstrapApp() {
	await import ('./bootstrap.js');
}

bootstrapApp().catch((error) => {
	console.error('Error loading bootstrap:',error);
});